import { fg } from '@confluence/feature-gating';

export const useCommentActionsVisibility = (
	isFabricPage?: boolean,
): {
	showMainActions: boolean;
	showLegacyMainActions: boolean;
} => {
	const isNotFabricPage = isFabricPage === false;

	const isFabricPageWithFeaturesEnabled =
		!isNotFabricPage && fg('confluence_frontend_content_wrapper');

	const showMainActions = isFabricPageWithFeaturesEnabled;
	const showLegacyMainActions = !isFabricPageWithFeaturesEnabled;

	return { showMainActions, showLegacyMainActions };
};
